export const setFilterUsers = (state, action) => ({
  ...state,
  filterUsers: action.filterUsers,
});

export const setFilterTags = (state, action) => ({
  ...state,
  filterTags: action.filterTags,
});

export const setFilterTeams = (state, action) => ({
  ...state,
  filterTeams: action.filterTeams,
});

export const setFilterScope = (state, action) => ({
  ...state,
  filterScope: action.filterScope,
});

export const clearAllFilters = (state, action) => ({
  ...state,
  filterUsers: [],
  filterTags: [],
  filterTeams: [],
  filterScope: {},
});
